import { api_registrarLogErroFrontend } from "@/frontend/services/api/api_others";
import React from "react";

//Util
import {
  fn_isErroImport,
  fn_recarregarPorErroImport,
} from "@/frontend/utils/versao";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      hasError: false,
      error: null,
    };
  }

  static getDerivedStateFromError(error) {
    return {
      hasError: true,
      error,
    };
  }

  componentDidCatch(error, errorInfo) {
    //Tela aberta antes de uma publicação: o arquivo da tela não existe mais no servidor.
    //Recarrega a página para buscar a versão nova, sem o usuário precisar clicar em Atualizar.
    //Se já recarregou há pouco e o erro continua, segue para a tela de erro com o botão
    if (fn_isErroImport(error) && fn_recarregarPorErroImport()) {
      return;
    }

    console.error("### ERRO CAPTURADO ###");
    console.error("Erro:", error);
    console.error("Stack:", error?.stack);
    console.error("Component Stack:", errorInfo?.componentStack);

    api_registrarLogErroFrontend({
      mensagem: error?.message,
      stack: error?.stack,
      componentStack: errorInfo?.componentStack,
      url: window.location.href,
    }).catch((erroLog) => {
      console.error("Erro ao enviar log do frontend:", erroLog);
    });
  }

  render() {
    if (this.state.hasError) {
      const message = String(this.state.error || "");

      const erroImport = fn_isErroImport(message);

      if (erroImport) {
        return (
          <div className="d-flex justify-content-center align-items-center vh-100">
            <div className="text-center">
              <h3>O sistema foi atualizado.</h3>

              <p>Uma nova versão foi publicada.</p>

              <button
                className="btn btn-primary"
                onClick={() => window.location.reload()}
              >
                Atualizar tela
              </button>
            </div>
          </div>
        );
      }

      return (
        <div className="p-4">
          <h3>Ocorreu um erro inesperado.</h3>

          <p>{message}</p>
        </div>
      );
    }

    return this.props.children;
  }
}
